const ALLOWED_PROTOCOLS = new Set(["http:", "https:"]);

export function getSafeRedirectUrl(url) {
  if (typeof url !== "string" || url.trim() === "") {
    return null;
  }
  try {
    // URL parses like the browser does, so tricks like " java\tscript:" are normalized
    const parsedUrl = new URL(url, window.location.origin);
    if (!ALLOWED_PROTOCOLS.has(parsedUrl.protocol)) {
      return null;
    }
    return parsedUrl.href;
  } catch {
    // An unparseable URL is treated as unsafe, so we never navigate to it
    return null;
  }
}

function navigateTo(pageToRedirect) {
  const safeUrl = getSafeRedirectUrl(pageToRedirect);
  if (safeUrl === null) {
    return;
  }
  window.location.assign(safeUrl);
}

export function redirectPage(pageToRedirect, timeout) {
  if (!timeout) {
    navigateTo(pageToRedirect);
    return;
  }
  const timer = setTimeout(() => {
    navigateTo(pageToRedirect);
    clearTimeout(timer);
  }, timeout);
}
